import styled from "styled-components";

export const ItemWrapper = styled.div(
  props => `
  padding: 0 1.6rem;
  border-bottom: 0.1rem #e5edf6 solid;
  background-color: ${props?.isBluSmart ? '#DAFBFD' : '#fff'};
  display: flex;
  :last-child {
    border-bottom: 0;
  }
`);
export const ItemLeftCont = styled.div`
  flex: 1;
  padding: 2.5rem 1.2rem 1.5rem 0;
  .itemLeftHead {
    display: flex;
    justify-content: space-between;
    margin-bottom: 1rem;
  }
  .cabTitle {
    font-family: 'Rubik';
    font-size: 1.6rem;
    line-height: 2.2rem;
    font-weight: 600;
    color: #141823;
  }
  .reviews {
    font-size: 1.2rem;
    color: #898b91;
    margin-right: 0.8rem;
    padding-right: 0.8rem;
    position: relative;
    ::after {
      width: 0.1rem;
      height: 2rem;
      background-color: #e5edf6;
      content: "";
      position: absolute;
      right: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .makeFlex.hrtlCenter {
    align-items: center;
  }
  .makeFlex {
    width: 49rem;
    display: flex;
  }
  .infoText {
    display: inline-flex;
    border-radius: 0.4rem;
    background-color: #fef8e5;
    padding: 0.4rem 1.2rem;
    font-size: 1.2rem;
    line-height: 1.6rem;
    color: #4f525a;
  }
  .safetyMeasure {
    display: flex;
    align-items: center;
    margin-bottom: 1.2rem;
  }
  .goSafeTag {
    height: 2.6rem;
    border-radius: 0.4rem;
    background-color: #e9f6ea;
    padding: 0 0.6rem;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 1rem;
  }
  .safetyMeasureList {
    display: flex;
    font-size: 1.2rem;
    color: #141823;
    > li {
      background-color: #e9f6ea;
      border-radius: 0.4rem;
      height: 2.6rem;
      padding: 1.3rem;
      display: flex;
      align-items: center;
      margin: 0 0 0 1.3rem;
      font-size: 1.4rem;
      cursor: pointer;
    }
    > span {
      margin: 0 0 0 7px;
      font-family: 'Rubik';
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.33;
      letter-spacing: normal;
      color: #141823;
    }
  }
  .rydeMeasureList {
    display: flex;
    font-size: 1.2rem;
    color: #141823;
    > li {
      border-radius: 0.4rem;
      height: 2.6rem;
      display: flex;
      align-items: center;
      font-size: 1.4rem;
      cursor: pointer;
    }
  }
`;
export const EngineType = styled.span(
  props => `
    display: inline-flex;
    align-items: center;
    justify-content: center;
    height: 2rem;
    width: 0.6rem;
    border-radius: 0.2rem;
    margin-right: 0.7rem;
    background-image: linear-gradient(162deg, ${props?.primaryColor ? props.primaryColor : "#1149f3"}, ${props?.secondaryColor ? props.secondaryColor : "#00c3ff"});
`);

export const RatingTag = styled.span`
  width: 4.2rem;
  height: 2.1rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0.4rem;
  font-size: 1.2rem;
  color: #fff;
  > span:first-child {
    font-weight: 600;
  }
  ${(props) =>
    props.bc &&
    `
      background-color: ${props.bc};
    `}
`;
export const ItemRightCont = styled.div`
  width: 210px;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  border-left: 0.1rem #e5edf6 solid;
  padding: 2.5rem 0 1.5rem 1.5rem;
  text-align: right;
  .fcText {
    font-size: 1.2rem;
    color: #2bac36;
  }
`;
export const ItemRightFooter = styled.div`
  margin-top: auto;
  display: flex;
  flex-direction: column;
  margin-bottom: auto;
  .discount {
    border-radius: 0.2rem;
    align-self: flex-end;
    display: flex;
    height: 2rem;
    align-items: center;
    background-color: #e6334a;
    .text {
      color: #fff;
      font-size: 1.2rem;
      margin: 0.4rem;
    }
    .circle {
      height: 0.6rem;
      width: 0.6rem;
      background-color: #fff;
      border-radius: 50%;
      z-index: 2;
    }
  }
  .shape {
    width: 0; 
    height: 0;
    margin-left: -1px;
    border-top: 1rem solid transparent;
    border-bottom: 1rem solid transparent;
    border-left: 1rem solid #e6334a;
  }
  .pointer {
    cursor: pointer;
  }
  .priceDtl {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .actualPrice {
    font-size: 1.2rem;
    color: #898b91;
    text-decoration: line-through;
  }
  .discountedPrice {
    font-family: 'Rubik';
    font-size: 2.2rem;
    font-weight: 600;
    color: #141823;
    margin-left: 0.7rem;
  }
  .inclusive {
    font-size: 1.2rem;
    color: #898b91;
    margin-bottom: 0.9rem;
  }
  .bpgText {
    color: #2bac36;
    font-size: 1.2rem;
    a {
      color: #2276e3;
      font-weight: 500;
    }
  }
  .bpgSubText {
    font-size: 1.2rem;
    color: #2bac36;
    line-height: 1.6rem;
  }
  .knowMore {
    font-family: 'Rubik';
    font-size: 1.2rem;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    color: #2276e3;
  }
  
`;

export const ToolTip = styled.div`
  position: absolute;
`;

export const DiscountOverlayWrapper = styled.div`
  position: relative;
  border-radius: 0.4rem;
  box-shadow: 0 0.3rem 0.3rem 0 rgba(185, 186, 210, 0.3);
  width: 36rem;
  top: ${props => props.top ? props.top : ''};
  box-sizing: border-box;
  
  &:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    bottom: -1em;
    left: 85%;
    box-sizing: border-box;
    border: 0.5em solid #141823;
    border-color: transparent transparent #fff #fff;
    transform-origin: 0 0;
    transform: rotate(-45deg);
    box-shadow: -0.3rem 0.3rem 0.3rem 0 rgba(185, 186, 210, 0.3);
  }
`;

export const ElectricVehicleImg = styled.img.attrs((props) => ({
  src: props.src || ""
}))`
  width: 25px;
  height: 20px;
  margin-right: 1rem;
`;

export const AddonCont = styled.div`
  padding: 8px 16px;
  gap: 12px;
  opacity: 0px;
  background-color: #E5FDFF;
  display: flex;
  align-items: center;
  font-family: 'Rubik';
  font-size: 14px;
`
